import { ModalCustom } from "components/ModalCustom";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import FileUpload from "components/UploadArquivos";
import { DropdownSelect } from "components/DropdownSelect";
import { useFornecedores } from "../../../Fornecedor/hooks/useFornecedores";
import { CustomInput } from "components/CustomInput";
import { ICriarLote } from "../../interface/ICriarLote";
import { ContainerForm } from "./style";
import { useMaskInput } from "hooks/useMaskInput";
import { criarLoteSchema } from "../../validate/criarLoteSchema";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: (dados: ICriarLote) => void;
}

export function ModalCriarLote({ show, handleClose, onSubmit }: Props) {
  const { optionsFornecedores, gerarOptionsFornecedores } = useFornecedores({
    semFiltroStatus: true,
  });
  const [tipoLancamentoDisabled, setTipoLancamentoDisabled] =
    useState<boolean>(false);

  const valoresDefaultForm = {
    tipoLancamento: "C",
    fornecedor: undefined,
    numeroNfRecibo: "",
    valorNfRecibo: "",
    arquivo: "",
  };

  const { mInputCoin } = useMaskInput();

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(criarLoteSchema),
  });

  useEffect(() => {
    if (show) {
      reset(valoresDefaultForm);
      setValue("tipoLancamento", "C");
      setTipoLancamentoDisabled(true);
      gerarOptionsFornecedores();
    }
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Criar novo lote de pagamento"
      centered
    >
      <form
        onSubmit={handleSubmit((dados: ICriarLote) => {
          onSubmit(dados);
        })}
      >
        <ContainerForm>
          <Form.Group>
            <Form.Label>
              Tipo de lançamento <Required />
            </Form.Label>
            <Controller
              control={control}
              name="tipoLancamento"
              render={({ field: { onChange, value } }) => (
                <DropdownSelect
                  options={[{ value: "C", label: "Custos Processo" }]}
                  selectedValue={value}
                  onSelect={onChange}
                  disabled={tipoLancamentoDisabled}
                  mensagemErro={errors.tipoLancamento?.message}
                  exibirValorDesabilitado
                />
              )}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label>
              Fornecedor <Required />
            </Form.Label>
            <Controller
              control={control}
              name="fornecedor"
              render={({ field: { onChange, value } }) => (
                <DropdownSelect
                  options={optionsFornecedores}
                  title=""
                  selectedValue={value}
                  onSelect={onChange}
                  searchable
                  mensagemErro={errors.fornecedor?.message}
                />
              )}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label>
              Nº Recibo / NF <Required />
            </Form.Label>
            <Controller
              control={control}
              name="numeroNfRecibo"
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  placeholder="Informe o nº do recibo ou NF emitido pelo fornecedor"
                  style={{ height: "2.2rem" }}
                  onChange={onChange}
                  value={value}
                  mensagemErro={errors.numeroNfRecibo?.message}
                  isInvalid={!!errors.numeroNfRecibo?.message}
                />
              )}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label>
              Valor total do recibo / NF <Required />
            </Form.Label>
            <Controller
              control={control}
              name="valorNfRecibo"
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  placeholder="Informe o valor do recibo ou NF emitido pelo fornecedor"
                  style={{ height: "2.2rem" }}
                  onChange={(e: any) =>
                    onChange(
                      mInputCoin({
                        ...e,
                        target: {
                          ...e.target,
                          value: e.target.value.replace(/[^0-9.]/g, ""),
                        },
                      })
                    )
                  }
                  value={value}
                  mensagemErro={errors.valorNfRecibo?.message}
                  isInvalid={!!errors.valorNfRecibo?.message}
                />
              )}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label style={{ color: temaPadrao.colors.neutral.neutral70 }}>
              Upload do arquivo <Required />
            </Form.Label>
            <Controller
              name="arquivo"
              control={control}
              render={({ field: { onChange } }) => (
                <FileUpload
                  onFileUpload={(file) => {
                    onChange(file);
                  }}
                  mensagemErro={errors.arquivo?.message}
                  comMaxWidth={false}
                  inputAccept=""
                />
              )}
            />
          </Form.Group>
        </ContainerForm>
        <div className="d-flex justify-content-end gap-4 mt-4">
          <PrimaryButton
            style={{ width: "10rem" }}
            outline
            variante="primary"
            onClick={handleClose}
            type="button"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton style={{ width: "13rem" }} type="submit">
            Escolher processos
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
